import { useSelector } from "react-redux";
import { QrReader } from "react-qr-reader";
import { Paper, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { QrCodeScanner } from "@mui/icons-material";
import { Fragment, useEffect, useRef, useState } from "react";

import ImgCapture from "./ImgCapture";
import { useAxios } from "../../hooks";

function Form({ formikProps }) {
  const axios = useAxios();
  const videoRef = useRef(null);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const hotelID = queryParams.get("hotel_id");

  const [cameraScreen, setCameraScreen] = useState("environment");
  const { visitorData } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: `/hotel/booking/check-guest-booking?visitor_id=${visitorData.ID}&hotel_id=${hotelID}`,
      method: "GET",
      disableError: true,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        formikProps.setFieldValue("QRCode", hotelID);
        formikProps.setFieldValue(
          "bookingID",
          response?.data?.hotel_booking_id
        );
      }
    });
  }, []);

  function handleBookingID(formikProps, ID) {
    axios({
      url: `/hotel/booking/check-guest-booking?visitor_id=${visitorData.ID}&hotel_id=${ID}`,
      method: "GET",
      disableError: true,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        formikProps.setFieldValue("QRCode", ID);
        formikProps.setFieldValue(
          "bookingID",
          response?.data?.hotel_booking_id
        );
      }
    });
  }

  return (
    <Fragment>
      {!formikProps.values.QRCode && (
        <Fragment>
          <Fragment>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                backgroundColor: "#f5faff",
                border: "1px solid #d0e2ff",
                textAlign: "center",
                mb: 2,
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={1}
                mb={2}
              >
                <QrCodeScanner color="primary" />
                <Typography variant="h6" fontWeight={600}>
                  Scan Machine QR Code
                </Typography>
              </Stack>

              <Box
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  mx: "auto",
                  borderRadius: 2,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <QrReader
                  style={{ width: "100%" }}
                  onResult={(result, error) => {
                    if (!!result) {
                      formikProps.setFieldValue("QRCode", result?.text);
                      // handleBookingID(formikProps, result?.text);
                    }
                    if (!!error) {
                      console.info("QR Scan Error:", error?.message);
                    }
                  }}
                  constraints={{ facingMode: "environment" }}
                  scanDelay={250}
                />
              </Box>
            </Paper>
          </Fragment>
        </Fragment>
      )}

      {formikProps.values.QRCode && (
        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: 3,
            backgroundColor: "#f5faff",
            border: "1px solid #d0e2ff",
            textAlign: "center",
            mb: 2,
          }}
        >
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mb={2}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={1}
              mb={2}
            >
              <QrCodeScanner color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Click Your Image
              </Typography>
            </Stack>
            <ImgCapture
              videoRef={videoRef}
              bioFormikProps={formikProps}
              cameraScreen={cameraScreen}
              onSubmit={formikProps.handleSubmit}
            />
          </Stack>
        </Paper>
      )}
    </Fragment>
  );
}

export default Form;
